import React from 'react';
import { getStatusBadgeConfig } from '../utils/invoiceUtils';

/**
 * Status Badge Component
 * Displays a colored badge for invoice status with optional FBR number
 */
const StatusBadge = ({
  status,
  showIcon = true,
  size = 'sm',
  fbrInvoiceNumber = null,
  showFbrNumber = false
}) => {
  const config = getStatusBadgeConfig(status);

  const sizeClasses = {
    xs: 'px-2 py-1 text-xs',
    sm: 'px-2.5 py-0.5 text-sm',
    md: 'px-3 py-1 text-base',
    lg: 'px-4 py-2 text-lg'
  };

  return (
    <div className="flex flex-col items-start space-y-1">
      <span
        className={`
          inline-flex items-center gap-1 font-medium rounded-full
          ${config.color}
          ${sizeClasses[size] || sizeClasses.sm}
        `}
        title={status}
      >
        {showIcon && (
          <span className="flex-shrink-0" aria-hidden="true">
            {config.icon}
          </span>
        )}
        <span>{config.text}</span>
      </span>

      {/* Show FBR Invoice Number under status badge if available */}
      {showFbrNumber && fbrInvoiceNumber && (
        <div className="text-left">
          <p className="text-xs text-gray-500">FBR #</p>
          <p className="text-xs font-mono font-bold text-blue-600 truncate max-w-32" title={fbrInvoiceNumber}>
            {fbrInvoiceNumber}
          </p>
        </div>
      )}
    </div>
  );
};

export default StatusBadge;
